var initializeFantasyFootballSkillPicker = function (controlId, locale) {
  const categorySelect = $("#" + controlId + "-category");

  categorySelect.on("change", (event) => {
    fantasyFootballSkillPickerUpdateSkills(controlId, locale);
  });
  const skillSelect = $("#" + controlId + "-skill");
  skillSelect.on("change", (event) => {
    fantasyFootballSkillPickerUpdateValue(controlId, locale);
  });
  const languageSelect = $("#" + controlId + "-language");
  languageSelect.on("change", (event) => {
    fantasyFootballSkillPickerUpdateSkills(controlId, locale);
  });
  fantasyFootballSkillPickerUpdateSkills(controlId, locale);
};

 

function sortSelectAndSelectFirstOption(querySelector) {
    const $select = $(querySelector);
    
    // Get the options as an array and sort by text
    const options = $select.find('option').toArray().sort((a, b) => {
        return $(a).text().localeCompare($(b).text());
    });

    // Clear the select element and re-append sorted options
    $select.empty().append(options);

    // Select the first option
    $select.prop('selectedIndex', 0);
}


var fantasyFootballSkillPickerUpdateSkills = function (controlId, locale) {
  const languageSelect = $("#" + controlId + "-language");
  const languageId = languageSelect.val();
  const categorySelect = $("#" + controlId + "-category");
  const skillSelect = $("#" + controlId + "-skill");
  const skillLabel = $("#" + controlId + "-skill-label");
  const valueEdit = $("#" + controlId + "-value");
  const category = categorySelect.val();
  skillSelect.empty();

  const skill_id_list = TTG.FantasyFootball.SkillsByCategory[category];
  for (var i = 0; i < skill_id_list.length; i++) {
    const skill_id = skill_id_list[i];
    const label = TTG.FantasyFootball.Strings[locale].skills[skill_id];
    skillSelect.append(
      $("<option>", {
        value: skill_id,
        text: label,
      })
    );
  }

  if (category == "traits") {
    skillLabel.text(TTG.FantasyFootball.Strings[locale].skill_types.trait);
  } else if (category == "characteristics") {
    skillLabel.text(TTG.FantasyFootball.Strings[locale].skill_types.characteristic);
  } else {
    skillLabel.text(TTG.FantasyFootball.Strings[locale].skill_types.skill);
  }

  sortSelectAndSelectFirstOption("#" + controlId + "-skill");
  fantasyFootballSkillPickerUpdateValue(controlId, locale);
};

var fantasyFootballSkillPickerUpdateValue = function (controlId, locale) {
  const languageSelect = $("#" + controlId + "-language");
  const languageId = languageSelect.val();
  const categorySelect = $("#" + controlId + "-category");
  const category = categorySelect.val();
  const skillSelect = $("#" + controlId + "-skill");
  const valueEdit = $("#" + controlId + "-value");
  const languageValueEdit = $("#" + controlId + "-language-value");
  
  // Set the language ID if we want the flag to show up on the Cart
  // $("#" + controlId + "-language-id").val(languageId);

  const hook = $(
    "#" + controlId + " .fantasy-football-skill-picker-preview-hook"
  );
  const hookSpan = $(
    "#" + controlId + " .fantasy-football-skill-picker-preview-hook span"
  );
  const skill_id = skillSelect.val();

  if (!TTG.Strings.isEmptyOrWhiteSpaces(skill_id)) {
    const label = TTG.FantasyFootball.Strings[languageId].skills[skill_id];
    const hookLabel = TTG.FantasyFootball.Strings[languageId].skill_hooks[skill_id];

    valueEdit.val(label);

    hookSpan.text(hookLabel);
    hook.attr("data-category", category);
    hook.show();

    if (category == "traits") {
      valueEdit.attr(
        "name",
        "properties[" + TTG.FantasyFootball.Strings[locale].skill_types.trait + "]"
      );
    } else if (category == "characteristics") {
      valueEdit.attr(
        "name",
        "properties[" + TTG.FantasyFootball.Strings[locale].skill_types.characteristic + "]"
      );
    } else {
      valueEdit.attr(
        "name",
        "properties[" + TTG.FantasyFootball.Strings[locale].skill_types.skill + "]"
      );
    }
  } else {
    hook.hide();
    valueEdit.val("");
  }
};
